import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const BlankLayoutContainer = styled.main`
  background-color: ${colors.primary};
  min-height: 100vh;

  &:has(.cs__page) {
    background-color: ${colors.white};
  }
`;
